/* import __COLOCATED_TEMPLATE__ from './emoji-reaction.hbs'; */
/* RESPONSIBLE TEAM: team-omni */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
// @ts-ignore
import intermoji from '@intercom/intermoji';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import type { Reaction } from 'embercom/objects/inbox/reaction';
import type EmojiService from 'embercom/services/emoji-service';
import type IntlService from 'ember-intl/services/intl';

interface Args {
  reaction: Reaction;
  isUserPart: boolean;
  isUnsupportedReaction?: boolean;
}

interface Signature {
  Args: Args;
}

export default class EmojiReaction extends Component<Signature> {
  @service declare emojiService: EmojiService;
  @service intl!: IntlService;

  get displayEmoji() {
    // Convert emoji code to unicode
    let unicodeEmoji = intermoji.unicodeFromIdentifier(this.args.reaction.emoji);

    if (!unicodeEmoji) {
      return `:${this.args.reaction.emoji}:`;
    }

    // Apply skin tone if applicable
    let skinTonedEmoji = this.emojiService.skinTonedModifiedEmoji(unicodeEmoji);

    // Check if browser supports native emoji rendering
    if (intermoji.hasNativeSupport(document)) {
      return skinTonedEmoji;
    } else {
      // Fallback to image rendering
      return sanitizeHtml(intermoji.fallbackImage(16, skinTonedEmoji, 'emoji__image'));
    }
  }

  get count() {
    return this.args.reaction.count > 99 ? '99+' : this.args.reaction.count.toString();
  }

  get reactors() {
    return this.args.reaction.reactors;
  }

  get tooltipContent() {
    let emoji = this.args.reaction.emoji;
    return this.intl.t('inbox.conversation-stream.emojis.reaction', {
      count: this.count,
      emoji: `:${emoji}:`,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    EmojiReaction: typeof EmojiReaction;
    'emoji-reaction': typeof EmojiReaction;
  }
}
